import { defineStore } from 'pinia'
import { getProjectInfo } from "@/api/common"

interface ProjectInfoState {
  projectInfo: any
}

export const useProjectInfoStore = defineStore('projectInfo', {
  state: (): ProjectInfoState => ({
    projectInfo: {}
  }),
  actions: {
    fetchProjectInfo() {
      return getProjectInfo().then((res:any) => {
        this.projectInfo = res.data;
      }).catch(err => {
        // Ignore canceled requests (harmless - occurs when user navigates away or refreshes)
        if (err.code === 'ERR_CANCELED' || err.name === 'CanceledError') {
          return;
        }
        console.error('Error in fetchProjectInfo:', err);
        throw err; 
      });
    }
  }
})